import { useMutation } from "react-query";
import { useApi } from "./useApi";
import { params } from "../params";

export type KnowledgeFileUploadResponse = {
  success: boolean;
  articleId: string;
};

export type KnowledgeFileUploadPayload = {
  file: File;
  title?: string;
  topicIds?: string[];
  brand?: string;
  knowledgeType?: 'kb' | 'wiki';
  noAccessToRelease?: boolean;
};

export function useKnowledgeFileUpload() {
  const { api } = useApi();

  return useMutation<KnowledgeFileUploadResponse, unknown, KnowledgeFileUploadPayload>(
    async ({ file, title, topicIds, brand, knowledgeType, noAccessToRelease }) => {
      const formData = new FormData();
      formData.append("file", file);
      
      if (title) {
        formData.append("title", title);
      }
      
      if (topicIds && topicIds.length > 0) {
        topicIds.forEach(topicId => {
          formData.append("topicIds", topicId);
        });
      }

      if (brand) {
        formData.append("brand", brand);
      }

      if (knowledgeType) {
        formData.append("knowledgeType", knowledgeType);
      }

      if (noAccessToRelease) {
        formData.append("noAccessToRelease", "true");
      }

      const res = await api.post(
        `${params.API_URL}/knowledge-base-handler/knowledge/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return res.data;
    }
  );
}
